import {apiUrl, apiOption, apiResponse, errorResponse} from '../core/fetchz'
import loading from '../core/redux/loading'
import config from '../config'

const NAMESPACE = 'OpeningTicketInstruction'

export const OPENING_TICKET_INSTRUCTION_STREAM_LOADED = NAMESPACE + '/OpeningTicketInstructionStreamLoaded'
export const OPENING_TICKET_INSTRUCTION_STREAM_QUERIED = NAMESPACE + '/OpeningTicketInstructionStreamQueried'
export const CREATE_OPENING_TICKET_INSTRUCTION_ACTION_SENT = NAMESPACE + '/CreateOpeningTicketInstructionActionSent'
export const UPDATE_OPENING_TICKET_INSTRUCTION_ACTION_SENT = NAMESPACE + '/UpdateOpeningTicketInstructionActionSent'
export const ASSOCIATE_OPENING_TICKET_PURPOSE_WITH_INSTRUCTION_ACTION_SENT = NAMESPACE + '/AssociateOpeningTicketPurposeWithInstructionActionSent'
export const DISSOCIATE_OPENING_TICKET_PURPOSE_FROM_INSTRUCTION_ACTION_SENT = NAMESPACE + '/DissociateOpeningTicketPurposeFromInstructionActionSent'
// form actions
export const CREATE_OPENING_TICKET_INSTRUCTION_ACTION_UPDATED = NAMESPACE + '/CreateOpeningTicketInstructionActionUpdated'
export const UPDATE_OPENING_TICKET_INSTRUCTION_ACTION_UPDATED = NAMESPACE + '/UpdateOpeningTicketInstructionActionUpdated'

export const DEFAULT_QUERY = {
}

export const DEFAULT_OPENING_TICKET_INSTRUCTION_QUERY = {
    ...DEFAULT_QUERY,
    openingTicketPurpose: null
}

export function queryOpeningTicketInstructionStream(companyId, instructionQuery) {
    return loadOpeningTicketInstructionStream(companyId, instructionQuery, OPENING_TICKET_INSTRUCTION_STREAM_QUERIED)
}

export function loadOpeningTicketInstructionStream(companyId, instructionQuery, action) {
    return loading((state) => {
        const {company} = state.company
        const {query} = state.message.openingTicketInstruction
        companyId = (companyId && companyId.uid) || companyId || company.uid

        instructionQuery = {
            ...DEFAULT_OPENING_TICKET_INSTRUCTION_QUERY,
            ...query,
            ...instructionQuery
        }

        return fetch(apiUrl(config.api.url + '/clientcompanies/' + companyId + '/openingticketinstructions', instructionQuery), apiOption())
        .then(apiResponse)
        .then(({json}) => {
            return {
                type: action || OPENING_TICKET_INSTRUCTION_STREAM_LOADED,
                stream: json.result,
                query: instructionQuery
            }
        })
    }, action || OPENING_TICKET_INSTRUCTION_STREAM_LOADED)
}

export function sendCreateOpeningTicketInstructionAction() {
    return loading((state) => {
        const {company} = state.company
        const {createOpeningTicketInstructionAction} = state.message

        const option = {
            method: 'PATCH',
            body: {
                action: 'CreateOpeningTicketInstruction',
                ...createOpeningTicketInstructionAction
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/openingticketinstructions', apiOption(option))
        .then(apiResponse)
        .then(({json}) => {
            return {
                type: CREATE_OPENING_TICKET_INSTRUCTION_ACTION_SENT,
                openingTicketInstructionUid: json.instructionUid
            }
        })
    }, CREATE_OPENING_TICKET_INSTRUCTION_ACTION_SENT)
}

export function sendUpdateOpeningTicketInstructionAction() {
    return loading((state) => {
        const {company} = state.company
        const {updateOpeningTicketInstructionAction} = state.message

        const option = {
            method: 'PATCH',
            body: {
                action: 'UpdateOpeningTicketInstruction',
                ...updateOpeningTicketInstructionAction
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/openingticketinstructions', apiOption(option))
        .then(errorResponse)
        .then(({json}) => {
            return {
                type: UPDATE_OPENING_TICKET_INSTRUCTION_ACTION_SENT
            }
        })
    }, UPDATE_OPENING_TICKET_INSTRUCTION_ACTION_SENT)
}

export function sendAssociateOpeningTicketPurposeWithInstructionAction(openingTicketInstructionId, openingTicketPurposeId) {
    return loading((state) => {
        const {company} = state.company

        const option = {
            method: 'PATCH',
            body: {
                action: 'AssociateOpeningTicketPurposeWithInstruction',
                instructionUid: openingTicketInstructionId,
                openingTicketPurposeUid: openingTicketPurposeId
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/openingticketinstructions', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: ASSOCIATE_OPENING_TICKET_PURPOSE_WITH_INSTRUCTION_ACTION_SENT
            }
        })
    }, ASSOCIATE_OPENING_TICKET_PURPOSE_WITH_INSTRUCTION_ACTION_SENT)
}

export function sendDissociateOpeningTicketPurposeFromInstructionAction(openingTicketInstructionId, openingTicketPurposeId) {
    return loading((state) => {
        const {company} = state.company

        const option = {
            method: 'PATCH',
            body: {
                action: 'DissociateOpeningTicketPurposeFromInstruction',
                instructionUid: openingTicketInstructionId,
                openingTicketPurposeUid: openingTicketPurposeId
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/openingticketinstructions', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: DISSOCIATE_OPENING_TICKET_PURPOSE_FROM_INSTRUCTION_ACTION_SENT
            }
        })
    }, DISSOCIATE_OPENING_TICKET_PURPOSE_FROM_INSTRUCTION_ACTION_SENT)
}

export function updateUpdateOpeningTicketInstructionAction(action) {
    return {
        action: action,
        type: UPDATE_OPENING_TICKET_INSTRUCTION_ACTION_UPDATED
    }
}


// WEBPACK FOOTER //
// ./lib/message/actions.js